import { Skeleton } from "@material-ui/lab";
import React from "react";

const LoadingBar = () => <Skeleton className="LoadingBar" animation="pulse" />;

export default LoadingBar;
